import { delay, Observable, of } from 'rxjs';

import { GetTeamsSelectOptionsResModel } from '../models';

export function teamsMock(): Observable<GetTeamsSelectOptionsResModel> {
  return of({ teams: ['First line support', 'HR Support', 'Frontend', 'HR Tech'] })
    .pipe(delay(500));
}
